// Make sure this file is the last vite_javascript_tag script tag after all the imports and global variables
import Rails from "@rails/ujs"
console.log(`Before Rails.start:  ${Date.now()}`)
Rails.start()

initialize_box();
change_on_form_select();
// select_all();
// deselect_all();

ReinitializeTruncate.initialize();
TruncateElement.initialize();
TruncateElementMaster.initialize();

initialize_remote_errors();
// initialize_errors();

page_state();
internal_links_handler();
more_options();
delete_row();
calendar_tooltip_handler();
toggle_tags_handler();
copy_to_clipboard();

auto_reinitialization();

initialize_animations();
initialize_survey_matrix();

initialize_date_time_picker_dynamics();

// automerge_columns is used only inside the admin/survey aggregate table
automerge_columns();

display_upload();
grid_draggable();

// attach_n_group_delete();
toggle_switch_focus();
//show_tooltip_on_hover();


document.addEventListener('click', function(e) {
  const target = e.target.closest('.allow-consent-cookie');
  if (!target) return;

  e.preventDefault();
  document.querySelector('.cc-btn.cc-allow')?.click();
});

///////////////////////////////////////////////////////
// STIMULUS STUFF
///////////////////////////////////////////////////////

import { Application } from "@hotwired/stimulus"
import { registerControllers } from 'stimulus-vite-helpers'

// Stimulus components from stimulus-components.com
import NestedForm from '../../assets/javascripts/controllers/nested_form_controller' // 'stimulus-rails-nested-form'
import ExtendedFormControls from '../../assets/javascripts/controllers/extended_form_controls_controller'
import AccountPasswordVisibility from '../../assets/javascripts/controllers/account/password_visibility_controller'
import CheckboxSelectAll from '../../assets/javascripts/controllers/admin/checkbox_select_all'
import Timeago from '@stimulus-components/timeago'
import ColorPicker from '@stimulus-components/color-picker'
import '@simonwep/pickr/dist/themes/classic.min.css'

// import '@simonwep/pickr/dist/themes/monolith.min.css'
// import '@simonwep/pickr/dist/themes/nano.min.css'

document.addEventListener('DOMContentLoaded', () => {
  console.log("Loading Stimulus")
  const application = window.Stimulus = Application.start()
  const controllers = import.meta.glob([
    '../../assets/javascripts/controllers/**/*_controller.js',
    '../../assets/javascripts/controllers/**/*_controller.ts'
  ], { eager: true })

  registerControllers(application, controllers)

  application.register('nested-form', NestedForm)
  application.register('extended-form-controls', ExtendedFormControls)
  application.register('account--password-visibility', AccountPasswordVisibility)
  application.register('checkbox-select-all', CheckboxSelectAll)
  application.register('timeago', Timeago)
  application.register('color-picker', ColorPicker)
  console.log("Stimulus loaded")
});
